import React from "react";
import { StyledInput, Label, StyledTextArea, StyledFileUploadInput, StyledDateInput } from "./styles";
import { Form } from "antd";
import { Rule } from "antd/lib/form";
import dayjs, { Dayjs } from 'dayjs';

interface InputProps {
  label: string;
  placeholder: string;
  fontWeight: string;
  rules?: Rule[];
  name?: string | string[];
  onChange?: any;
  onBlur?: any;
  hidden?: boolean;
  disabled?: boolean;
}

const Input: React.FC<InputProps> = ({ label, placeholder, fontWeight, rules = [], onChange, name, onBlur, hidden, disabled = false }) => {
  return (
    <Form.Item name={name} label={<Label fontWeight={fontWeight}>{label}</Label>} rules={rules} validateTrigger={['onChange', 'onFinish', 'onBlur']} hidden={hidden}>
      <StyledInput placeholder={placeholder} onChange={onChange} onBlur={onBlur} disabled={disabled} />
    </Form.Item>
  );
};

export default Input;

interface TextAreaProps {
  label: string;
  placeholder: string;
  height?: string;
  fontWeight: string;
  rules?: Rule[];
  name?: string | string[];
  onChange?: any;
  onBlur?: any;
  disabled?: boolean;
}

export const TextArea: React.FC<TextAreaProps> = ({ label, disabled, placeholder, height, fontWeight, rules = [], name, onChange, onBlur }) => {
  return (
    <div>
      <Form.Item name={name} rules={rules} label={<Label fontWeight={fontWeight}>{label}</Label>} validateTrigger={['onChange', 'onFinish', 'onBlur']}>
        <StyledTextArea disabled={disabled} placeholder={placeholder} height={height} onChange={onChange} onBlur={onBlur} />
      </Form.Item>
    </div>
  );
};
interface DateInputProps {
  label: string;
  placeholder: string;
  fontWeight: string;
  rules?: Rule[];
  name?: string;
  onChange?: any;
  multiple?: boolean;
  isDisabledFutureDate?: boolean;
  disabled?: boolean;
}

export const FileUploadInput: React.FC<DateInputProps> = ({ label, placeholder, fontWeight, rules = [], name, onChange, multiple = false }) => {
  return (
    <Form.Item name={name} rules={rules} label={<Label fontWeight={fontWeight}>{label}</Label>}>
      <StyledFileUploadInput placeholder={placeholder} multiple={multiple} type="file" onChange={onChange} />
    </Form.Item>
  );
};

const disabledFutureDate = (current: Dayjs | null): boolean => {
  return !!current && current.isAfter(dayjs().endOf("day"));
};

export const DateInput: React.FC<DateInputProps> = ({ label, placeholder, fontWeight, rules = [], onChange, name, isDisabledFutureDate = true, disabled = false }) => {
  return (
    <div>
      <Form.Item name={name} rules={rules} label={<Label fontWeight={fontWeight}>{label}</Label>}>
        <StyledDateInput disabled={disabled} disabledDate={isDisabledFutureDate ? disabledFutureDate : undefined} placeholder={placeholder} onChange={onChange} format="MM/DD/YYYY" />
      </Form.Item>
    </div>
  );
};
